<template>
    <div class="header-wrapper">
        <div class="header">
            <div class="max-width">
                <div class="header-wrap">
                    <div class="logo-wrap">
                        <img src="../../assets/img/logo.png" alt="" class="logo-img phoneHide">
                        <img src="../../assets/img/index/logo-white.png" alt="" class="logo-img pcHide" >
                    </div>
                    <!-- <div class="banner-box">
                        <a href="https://merchant.wishpay-global.com/#/login" target="_blank" class="banner-btn">商家入口</a>
                        <a href="https://agent.wishpay-global.com/#/login" target="_blank" class="banner-btn">合作夥伴入口</a>
                    </div> -->
                    <div class="menu-wrap phoneHide">
                        <router-link to="/index">首頁</router-link>
                        <a class="subs" @click="clickmenu(0)">
                            <span class="big-munu">產品介紹</span>
                            <ul class="sub-menu">
                                <li @click.stop="clickmenu(1)" :class="productActive==1?'active':''">> 門店管理</li>
                                <li @click.stop="clickmenu(2)" :class="productActive==2?'active':''">> Wish Pay商戶端</li>
                                <li @click.stop="clickmenu(3)" :class="productActive==3?'active':''">> Wish Pay代理端</li>
                            </ul>
                        </a>
                        <router-link to="/partner">合作商戶</router-link>
                        <router-link to="/about">關於我們</router-link>
                        <router-link to="/global">全球合夥人</router-link>
                        <a href="https://merchant.wishpay-global.com/#/login" target="_blank">商戶登錄</a>
                        <a href="https://agent.wishpay-global.com/#/login" target="_blank">代理登錄</a>
                    </div>
                    <div class="menu-wrap-phone pcHide" >
                        <img src="../../assets/img/index/menu.png" alt="" class="menu-img" @click.stop="menuShow=!menuShow">
                        <div class="menu-box" v-show="menuShow" @click.stop="menuShow=!menuShow">
                            <ul>
                                <router-link to="/index" tag="li">首頁</router-link>
                                <router-link to="/product" tag="li">產品介紹</router-link>
                                <router-link to="/partner" tag="li">合作商戶</router-link>
                                <router-link to="/about" tag="li">關於我們</router-link>
                                <router-link to="/global"  tag="li">全球合夥人</router-link>
                                <router-link to="/merchantLoad" tag="li">商戶APP下載</router-link>
                                <router-link to="/agentLoad" tag="li">代理APP下載</router-link>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  inject: ['reload'],
  data () {
    return {
      menuShow: false,
      productActive: 0
    }
  },
  mounted () {
    this.productActive = this.$route.query.productActive
  },
  methods: {
    clickmenu: function (id) {
      this.$router.push('/product?productActive=' + id)
      this.reload()
    }
  }
}
</script>

<style lang="stylus" scoped>
.max-width{
    width 1150px
    max-width 1150px
    margin 0 auto
}
.header
    width 100%;
    background-color: #17181D;
    position:fixed;
    top:0;
    z-index:99;
    box-shadow 3px 3px 5px rgba(0,0,0,0.1)
    .header-wrap
        height 80px;
        display:flex;
        align-items center
        justify-content space-between
        .logo-wrap
            width 107px;
            .logo-img
                width 107px;
                vertical-align middle
        .menu-wrap
            color #ffffff
            font-size 15px
            a
                color #ffffff
                margin-left 30px
                padding 5px 0
            a:hover
                border-bottom 2px solid #fff
            .router-link-active
                border-bottom 2px solid #fff
            .subs
                position relative
                .big-munu:after
                    content ""
                    display inline-block
                    width 0px
                    height 0px
                    border-right 4px solid transparent
                    border-left 4px solid transparent
                    border-bottom 4px solid transparent
                    border-top 4px solid #ffffff
                    position absolute
                    right -7px
                    top 12px
                .sub-menu
                    opacity 0
                    position absolute
                    background #2B2B2B
                    width 155px
                    left 0px
                    top 30px
                    li
                        padding 10px 15px
                        font-size 13px
                    .active
                        color #F9B91A
                .router-link-active
                    border-bottom none
                .router-link-exact-active
                    border-bottom none
                    color #F9B91A
            .subs:hover
                .sub-menu
                    opacity 1
                    transition: all 0.5s ease !important;

@media screen and (max-width: 1024px)
    .max-width{
        width 90%
        max-width 90%
        margin 0 auto
    }
    .header
        width 100%;
        background-color: #fff;
        position:fixed;
        top:0;
        box-shadow 3px 3px 5px rgba(0,0,0,0.1)
        .header-wrap
            height 60px;
            display:flex;
            align-items center
            justify-content space-between
            .logo-wrap
                width 107px;
                .logo-img
                    width 80px;
                    vertical-align middle
            .menu-wrap-phone
                color #2B2B2B
                font-size 14px
                .menu-img
                    width 30px
                .menu-box
                    position absolute
                    right 0
                    top 60px
                    background #fff
                    z-index 99
                    width 150px
                    ul
                        margin 10px 0
                        li
                            padding 10px 0
                            text-align center
                        .router-link-exact-active
                            color #e2a817
</style>



// WEBPACK FOOTER //
// src/components/pc/header.vue